import { loadingReducer } from '../loading/reducer';
import { CONNECT_WALLET_REQUEST, CONNECT_WALLET_SUCCESS, CONNECT_WALLET_FAILURE, DISCONNECT_WALLET, CHANGE_ACCOUNT, CHANGE_NETWORK, ENABLE_WALLET_REQUEST, ENABLE_WALLET_SUCCESS, ENABLE_WALLET_FAILURE, FETCH_WALLET_REQUEST, FETCH_WALLET_SUCCESS, FETCH_WALLET_FAILURE, SET_APP_CHAIN_ID, SWITCH_NETWORK_REQUEST, SWITCH_NETWORK_SUCCESS, SWITCH_NETWORK_FAILURE } from './actions';
export const INITIAL_STATE = {
    data: null,
    loading: [],
    error: null,
    appChainId: null
};
export function walletReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case FETCH_WALLET_REQUEST:
        case ENABLE_WALLET_REQUEST:
        case CONNECT_WALLET_REQUEST: {
            return {
                ...state,
                loading: loadingReducer(state.loading, action)
            };
        }
        case SWITCH_NETWORK_REQUEST: {
            return {
                ...state,
                loading: loadingReducer(state.loading, action),
                error: null
            };
        }
        case FETCH_WALLET_SUCCESS:
        case CONNECT_WALLET_SUCCESS: {
            return {
                ...state,
                loading: loadingReducer(state.loading, action),
                error: null,
                data: action.payload.wallet
            };
        }
        case SWITCH_NETWORK_SUCCESS:
        case ENABLE_WALLET_SUCCESS: {
            return {
                ...state,
                loading: loadingReducer(state.loading, action),
                error: null
            };
        }
        case FETCH_WALLET_FAILURE: {
            return {
                ...state,
                loading: loadingReducer(state.loading, action)
            };
        }
        case SWITCH_NETWORK_FAILURE: {
            console.log('action.payload.error: ', action.payload.error);
            return {
                ...state,
                error: action.payload.error,
                loading: loadingReducer(state.loading, action)
            };
        }
        case CONNECT_WALLET_FAILURE: {
            return {
                ...state,
                loading: loadingReducer(state.loading, action),
                data: null
            };
        }
        case ENABLE_WALLET_FAILURE: {
            return {
                ...state,
                loading: loadingReducer(state.loading, action),
                error: action.payload.error,
                data: null
            };
        }
        case CHANGE_ACCOUNT:
        case CHANGE_NETWORK: {
            return {
                ...state,
                error: null,
                data: action.payload.wallet
            };
        }
        case DISCONNECT_WALLET: {
            return {
                ...state,
                error: null,
                data: null
            };
        }
        case SET_APP_CHAIN_ID: {
            return {
                ...state,
                appChainId: action.payload.chainId
            };
        }
        default:
            return state;
    }
}
//# sourceMappingURL=reducer.js.map